import AntUpload from 'antd/lib/upload';

export const Upload = AntUpload;
export const { Dragger: UploadDragger } = AntUpload;
